import { useMe } from "./useMe";

import type { Role } from "@/api/auth";

export function useRole(): Role | undefined {
  const { data } = useMe();
  return data?.role;
}

export function useCanEdit(roles: Role[] = ["admin", "super_admin"]): boolean {
  const role = useRole();
  return role !== undefined && roles.includes(role);
}
